import { ControlSheetTrip } from '../types/types'
import { standardizeTime } from './standardizeTime'

export const tripContainsTime = (trip: ControlSheetTrip, time: string): boolean => {
    const sorted = trip.breakpoints
        .filter((it) => it !== 'SKIP_CELL' && it !== null)
        .sort((a, b) => {
            return standardizeTime(a.time).localeCompare(standardizeTime(b.time))
        })

    const standardizedTime = standardizeTime(time)

    const first = sorted[0]
    const last = sorted[sorted.length - 1]

    if (first && last) {
        const tripStartTime = standardizeTime(first.time)
        const tripEndTime = standardizeTime(last.time)
        return standardizedTime >= tripStartTime && standardizedTime <= tripEndTime
    }

    return false
}
